import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import html2pdf from "html2pdf.js";
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

//Style
import "./FormComponent.css";

//Components
import SimulatorPdf from "../SimulatorPdf/SimulatorPdf";

const FormComponent = () => {
  const [totalValueFirstPayment, setTotalValueFirstPayment] = useState(0);

  const [separationValue, setSeparationValue] = useState(0);

  const [disableSubmit, setDisableSubmit] = useState(false);

  const [creditData, setCreditData] = useState({
    name: "",
    type_doc: "",
    num_doc: "",
    phone: "",
    email: "",
    block: "",
    floor: "",
    apartment: "",
    total_price: "",
    separation_value: "",
    subsidy_value: "",
    init_payment: "",
    init_fee: "",
    init_fee_to_pay: "",
    monthly_income: "",
    parking_floor: "",
    parking_number: "",
    total_price_30_percent: "",
  });

  const { control, handleSubmit, reset, watch, setValue, getValues } = useForm({
    defaultValues: creditData,
  });

  const apartmentsNumberByBlockA = [
    101, 102, 103, 104, 201, 202, 203, 204, 301, 302, 303, 304, 401, 402, 403,
    404, 501, 502, 503, 504, 601, 602, 603, 604, 701, 702, 703, 704, 801, 802,
    803, 804, 901, 902, 903, 904, 1001, 1002, 1003, 1004, 1101, 1102, 1103,
    1104, 1201, 1202, 1203, 1204,
  ];

  const apartmentsNumberByBlockB = [
    101, 102, 103, 104, 105, 106, 107, 108, 201, 202, 203, 204, 205, 206, 207,
    208, 301, 302, 303, 304, 305, 306, 307, 308, 401, 402, 403, 404, 405, 406,
    407, 408, 501, 502, 503, 504, 505, 506, 507, 508, 601, 602, 603, 604, 605,
    606, 607, 608, 701, 702, 703, 704, 705, 706, 707, 708, 801, 802, 803, 804,
    805, 806, 807, 808, 901, 902, 903, 904, 905, 906, 907, 908, 1001, 1002,
    1003, 1004, 1005, 1006, 1007, 1008, 1101, 1102, 1103, 1104, 1105, 1106,
    1107, 1108, 1201, 1202, 1203, 1204, 1205, 1206, 1207, 1208,
  ];

  const selectedBlock = watch("block");
  const selectedApartment = watch("apartment");
  const inputInitPayment = watch("init_payment");
  const inputSeparationValue = watch("separation_value");
  const inputSubsidyValue = watch("subsidy_value");

  const availableApartments = useMemo(() => {
    if (selectedBlock === "A") return apartmentsNumberByBlockA;
    if (selectedBlock === "B") return apartmentsNumberByBlockB;
    return [];
  }, [selectedBlock]);

  useEffect(() => {
    setValue("apartment", "");
  }, [selectedBlock, setValue]);

  useEffect(() => {
    const apartmentValue = getValues("apartment");
    const blockValue = getValues("block");
    const initPaymentValue = getValues("init_payment");
    const separationValue = getValues("separation_value");
    const subsidyValue = getValues("subsidy_value");

    let totalPriceByApartment = 0;

    switch (blockValue) {
      case "A":
        if (apartmentValue >= 101 && apartmentValue <= 204) {
          totalPriceByApartment = 252835977;
        } else if (apartmentValue >= 301 && apartmentValue <= 404) {
          totalPriceByApartment = 254579674;
        } else if (apartmentValue >= 501 && apartmentValue <= 604) {
          totalPriceByApartment = 256323370;
        } else if (apartmentValue >= 701 && apartmentValue <= 704) {
          totalPriceByApartment = 258067067;
        } else if (apartmentValue >= 801 && apartmentValue <= 1104) {
          totalPriceByApartment = 261554459;
        } else if (apartmentValue >= 1201 && apartmentValue <= 1204) {
          totalPriceByApartment = 258067067;
        }

        break;

      case "B":
        if (apartmentValue >= 101 && apartmentValue <= 208) {
          totalPriceByApartment = 252835977;
        } else if (apartmentValue >= 301 && apartmentValue <= 408) {
          totalPriceByApartment = 254579674;
        } else if (apartmentValue >= 501 && apartmentValue <= 608) {
          totalPriceByApartment = 256323370;
        } else if (apartmentValue >= 701 && apartmentValue <= 708) {
          totalPriceByApartment = 258067067;
        } else if (apartmentValue >= 801 && apartmentValue <= 1108) {
          totalPriceByApartment = 261554459;
        } else if (apartmentValue >= 1201 && apartmentValue <= 1208) {
          totalPriceByApartment = 258067067;
        }
        break;

      default:
        break;
    }

    const totalValueFirstPayment = totalPriceByApartment * 0.3;

    const totalValueWithSubs =
      Number(totalValueFirstPayment) -
      Number(initPaymentValue) -
      Number(separationValue) -
      Number(subsidyValue);

    setTotalValueFirstPayment(totalValueWithSubs);
    setSeparationValue(separationValue);

    setValue("total_price_30_percent", totalValueFirstPayment);
    setValue("init_fee_to_pay", totalValueWithSubs);

    setCreditData({
      ...creditData,
      total_price: totalPriceByApartment,
      total_price_30_percent: totalValueFirstPayment,
      init_fee_to_pay: totalValueWithSubs,
      separation_value: separationValue,
      subsidy_value: subsidyValue,
      init_payment: initPaymentValue,
      block: blockValue,
      apartment: apartmentValue,
    });
  }, [
    selectedApartment,
    inputInitPayment,
    inputSeparationValue,
    inputSubsidyValue,
  ]);

  const convertToPDF = async () => {
    const element = document.getElementById("section-pdf");
    const copy = element.cloneNode(true);

    element.style.display = "none";
    copy.style.display = "block";

    const tempContainer = document.createElement("div");
    tempContainer.appendChild(copy);

    const opt = {
      margin: 0,
      filename: `simulación.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { format: "a3", unit: "mm", orientation: "portrait" },
    };

    const worker = html2pdf().from(tempContainer).set(opt);

    await worker.save();

    const pdfBlob = await worker.outputPdf("blob");

    element.style.display = "none";

    return new File([pdfBlob], "simulador.pdf", { type: "application/pdf" });
  };

  const onSubmit = async (data) => {
    setDisableSubmit(true);

    setCreditData({
      ...creditData,
      name: data.name,
      type_doc: data.type_doc,
      num_doc: data.num_doc,
      phone: data.phone,
      email: data.email,
      floor: data.floor,
      monthly_income: data.monthly_income,
      parking_floor: data.parking_floor,
      parking_number: data.parking_number,
    });

    await new Promise((resolve) => setTimeout(resolve, 2000));

    try {
      const pdfFile = await convertToPDF();
      const formData = new FormData();

      let message = `Hola, estos son los datos de tu simulación: Nombre completo: ${data?.name}, Tipo de documento: ${data?.type_doc}, Número de documento: ${data?.num_doc}, Correo electronico: ${data?.email}, Ingresos mensuales: ${data?.monthly_income}, Celular: ${data?.phone}, Torre: ${data?.block}, Piso: ${data?.floor}, Número de apartamento: ${data?.apartment}, Piso parqueadero: ${data?.parking_floor}, Número parqueadero: ${data?.parking_number}, Total precio apartamento: ${data.total_price}, Valor separación: ${data?.separation_value}, Valor subsidio: ${data?.subsidy_value}, Abono inicial: ${data?.init_payment}`;

      formData.append("message", message);
      formData.append("sender", ["jabocachica@otacc.com"]);
      formData.append("subject", "Simulación Reserva del Prado - OTACC");
      formData.append("other", pdfFile);

      const response = await fetch("https://back-crediseguro.com/sendDocs", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      switch (result.message) {
        case "Correo electrónico enviado con éxito":
          setDisableSubmit(false);
          reset();
          break;

        default:
          break;
      }
    } catch (err) {
      throw new Error("Un error inesperado ha ocurrido:", err);
    }
  };

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <form className="form-container" onSubmit={handleSubmit(onSubmit)}>
        <Box
          component="section"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            justifyContent: "center",
            columnGap: 2,
            rowGap: 2,
            pt: 2,
            pb: 2,
          }}
        >
          <Controller
            name="name"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Nombre completo"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="type_doc"
            control={control}
            render={({ field }) => {
              return (
                <FormControl sx={{ minWidth: 185 }}>
                  <InputLabel id="demo-simple-select-label">
                    Tipo de documento
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={field.value}
                    onChange={field.onChange}
                    label="Tipo de documento"
                  >
                    <MenuItem value="">-- Selecciona --</MenuItem>
                    <MenuItem value="Cédula de ciudadanía">
                      Cédula de ciudadanía
                    </MenuItem>
                    <MenuItem value="Cédula de extranjería">
                      Cédula de extranjería
                    </MenuItem>
                    <MenuItem value="Pasaporte">Pasaporte</MenuItem>
                    <MenuItem value="Permiso por Protección Temporal (PPT)">
                      Permiso por Protección Temporal (PPT)
                    </MenuItem>
                    <MenuItem value="Documento de identidad extranjero">
                      Documento de identidad extranjero
                    </MenuItem>
                  </Select>
                </FormControl>
              );
            }}
          />
          <Controller
            name="num_doc"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="No. de documento"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="email"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Correo electrónico"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="monthly_income"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Ingresos mensuales"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="phone"
            control={control}
            render={({ field }) => {
              return (
                <TextField label="Celular" variant="outlined" {...field} />
              );
            }}
          />
          <Controller
            name="block"
            control={control}
            render={({ field }) => {
              return (
                <FormControl sx={{ minWidth: 185 }}>
                  <InputLabel id="demo-simple-select-label">Torre</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={field.value}
                    onChange={field.onChange}
                    label="Torre"
                  >
                    <MenuItem value="">-- Selecciona --</MenuItem>
                    <MenuItem value="A">A</MenuItem>
                    <MenuItem value="B">B</MenuItem>
                  </Select>
                </FormControl>
              );
            }}
          />
          <Controller
            name="floor"
            control={control}
            render={({ field }) => {
              return <TextField label="Piso" variant="outlined" {...field} />;
            }}
          />
          <Controller
            name="apartment"
            control={control}
            render={({ field }) => {
              return (
                <FormControl sx={{ minWidth: 185 }}>
                  <InputLabel id="demo-simple-select-label">
                    No. de apartamento
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={field.value}
                    onChange={field.onChange}
                    label="No. de apartamento"
                  >
                    <MenuItem value="">--Selecciona--</MenuItem>
                    {availableApartments.map((num) => (
                      <MenuItem key={num} value={num}>
                        {num}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              );
            }}
          />
          <Controller
            name="parking_floor"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Piso parqueadero"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="parking_number"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Número parqueadero"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="separation_value"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Valor separacion"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="subsidy_value"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Valor subsidio"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="init_payment"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Abono inicial"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="total_price_30_percent"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Valor total apartamento (30%)"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          <Controller
            name="init_fee_to_pay"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label=" Cuota Inicial a pagar"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          {/* <Controller
            name="init_fee"
            control={control}
            render={({ field }) => {
              return (
                <TextField
                  label="Cuota Inicial"
                  variant="outlined"
                  {...field}
                />
              );
            }}
          />
          */}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            disabled={disableSubmit}
            sx={{ width: "15rem" }}
            variant="contained"
            type="submit"
          >
            Generar Simulación
          </Button>
        </Box>
      </form>
      <div
        id="section-pdf"
        className="sim-preview-container"
        style={{ display: "none" }}
      >
        <SimulatorPdf
          totalPremium={totalValueFirstPayment}
          paymentPremium={separationValue}
          creditData={creditData}
          paymentDate={"2025-06-05"}
          termMonth={38}
        />
      </div>
    </Container>
  );
};

export default FormComponent;
